import { OrganizationSwitcher, UserButton } from "@clerk/clerk-react";
import { Center, Flex, Group, Paper, useMatches } from "@mantine/core";
import { Link } from "@tanstack/react-router";

import logo from "@/assets/logo-mn.svg";

export function HeaderBase({ children }: { children: React.ReactNode }) {
  return (
    <Paper h={56} withBorder px="md">
      <Flex gap="md" h={56} justify="space-between" align="center">
        <Group>
          <Center>
            <Link to="/">
              <img src={logo} alt="Museum Nord" height={28} />
            </Link>
          </Center>
        </Group>

        {children}
      </Flex>
    </Paper>
  );
}

export function HeaderUser() {
  const showAuthName = useMatches({
    base: false,
    md: true,
  });

  return (
    <Group align="center" gap="xs">
      <OrganizationSwitcher hidePersonal afterSelectOrganizationUrl="/" />
      <UserButton showName={showAuthName} />
    </Group>
  );
}
